import HNSColors from "../../../../HNSColors";

const HisArrowUp = ({ color, sx }) => {
  const strokeColor = color ?? HNSColors.success[400];
  const _sx = sx ?? {};
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={_sx}
    >
      <path
        stroke={strokeColor}
        d="M8.03752 0.798748C8.60148 0.0231863 9.75789 0.0231864 10.3219 0.798748L17.5489 10.7374C18.2276 11.6709 17.5608 12.9802 16.4067 12.9802L1.95268 12.9802C0.798549 12.9802 0.131758 11.6709 0.810513 10.7374L8.03752 0.798748Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default HisArrowUp;
